'use strict';
import Vue from 'vue';
import App from '@framework/app';
import createStore from '@store/index';
import createRouter from '@client/page/mobile/router/index';
import entry from '@client/page/mobile/view/entry/error/notfound/index.vue';
// import directives from '@client/page/mobile/directives/index';

// Vue.use(directives);
export default new App({ entry, createStore, createRouter }).bootstrap();